<template>
  <div
    data-allow-mismatch="style"
    class="tw-min-h-[50vh]"
    :class="[isHomepage ? 'md:!tw-pt-20 !tw-pt-[68px]' : 'md:!tw-pt-20 !tw-pt-[68px]']"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isHomepage: boolean;
}>();
</script>
